$('.custom-ingredients-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: `<button type="button" class="slick-prev">
                    
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fcfded">
  <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
</svg>

                </button>`,
    nextArrow: `<button type="button" class="slick-next">
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fcfded">
  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
</svg> </button>`,
   responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                 autoplay: false,
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
            }
        }
    ]
});


// tabs
  // document.addEventListener("DOMContentLoaded", function() {
  //   const tabs = document.querySelectorAll('.tab');
  //   const tabContents = document.querySelectorAll('.tab-inner-content');
    
  //   function resetTabs() {
  //     tabs.forEach(tab => tab.classList.remove('active'));
  //     tabContents.forEach(content => content.classList.remove('active'));
  //   }

  //   function setActiveTab(index) {
  //     tabs[index].classList.add('active');
  //     tabContents[index].classList.add('active');
  //   }

  //   tabs.forEach((tab, index) => {
  //     tab.addEventListener('click', function() {
  //       resetTabs();
  //       setActiveTab(index);
  //     });
  //   });

  //   setActiveTab(0);
  // });


// document.addEventListener("DOMContentLoaded", function() {
//     const tabs = document.querySelectorAll('.tab');
//     const tabContents = document.querySelectorAll('.tab-inner-content');

//     function resetTabs() {
//         tabs.forEach(tab => tab.classList.remove('active'));
//         tabContents.forEach(content => content.classList.remove('active'));
//     }

//     function setActiveTab(index) {
//         tabs[index].classList.add('active');
//         tabContents[index].classList.add('active');
//     }

//     tabs.forEach((tab, index) => {
//         tab.addEventListener('click', function() {
//             resetTabs();
//             setActiveTab(index);
//         });

//         // Add hover functionality for desktop
//         tab.addEventListener('mouseenter', function() {
//             if (window.innerWidth >= 1024) { // Check if the screen width is 768px or more
//                 resetTabs(); // Reset all tabs
//                 tab.classList.add('active'); // Add active class to hovered tab
//                 tabContents[index].classList.add('active'); // Show corresponding content
//             }
//         });

//         tab.addEventListener('mouseleave', function() {
//             if (window.innerWidth >= 1024) { // Check if the screen width is 768px or more
//                 // Only remove active class if the tab is not currently selected
//                 if (!tab.classList.contains('active')) {
//                     tab.classList.remove('active');
//                     tabContents[index].classList.remove('active');
//                 }
//             }
//         });
//     });

//     setActiveTab(0); // Set the first tab as active by default
// });

$(document).ready(function() {
  $('.tab-label').on('click', function() {
    var tab = $(this).closest('.tab'); // Get the closest .tab container
    var tabContent = tab.find('.tab-content-text'); // Find the tab content inside the clicked tab

    // Toggle the 'open' class
    tab.toggleClass('open');
    
    // If the tab is open, slide down the content, otherwise slide it up
    if (tab.hasClass('open')) {
      tabContent.stop(true, true).slideDown(); // Slide down (show) the tab content
    } else {
      tabContent.stop(true, true).slideUp(); // Slide up (hide) the tab content
    }

    // Close other tabs
    $('.tab').not(tab).each(function() {
      var otherTabContent = $(this).find('.tab-content-text');
      if ($(this).hasClass('open')) {
        $(this).removeClass('open');
        otherTabContent.stop(true, true).slideUp(); // Close other tabs with slideUp
      }
    });
  });
});


// rotational image
document.addEventListener('DOMContentLoaded', () => {
    const targetSections = document.querySelectorAll('.transform-animation');
    let lastScrollTop = 0;
    
    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }
    
    function onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const delta = scrollTop - lastScrollTop;
        lastScrollTop = scrollTop;
        
        targetSections.forEach(section => {
            // Get all fruit icons in this section instead of just the first one
            const fruitIcons = section.querySelectorAll('.fruit-icon-img img'); 
            const sectionRect = section.getBoundingClientRect();
            
            if (sectionRect.top < window.innerHeight && sectionRect.bottom >= 0 && fruitIcons.length > 0) {
                const scrollPercent = Math.min(1, Math.abs(sectionRect.top) / window.innerHeight);
                const rotationAngle = (scrollPercent * 90) - 40;
                const speedAdjustedRotation = rotationAngle + (delta * 0.2); 
                fruitIcons.forEach(fruitIcon => {
                    fruitIcon.style.transform = `rotate(${speedAdjustedRotation}deg)`;
                });
            }
        });
    }
    
    window.addEventListener('scroll', debounce(onScroll, 10));
});


// home-banner bear animation
let previousScrollPosition = 0;
let translateYValue = 0;
let translateFactor = 4;

function updateTranslateFactor() {
  if (window.innerWidth <= 768) {
    translateFactor = 10;
  } else {
    translateFactor = 4;
  }
}

window.addEventListener('resize', function() {
  updateTranslateFactor();
  
  if (window.innerWidth <= 1400) {
    translateYValue = 0; // Reset translateYValue when screen width is <= 1400
    const bannerImg = document.querySelector('.banner-bottom-img img');
    if(bannerImg) {
        bannerImg.style.transform = `translate(0%, ${translateYValue}px)`; // Apply reset transform
        previousScrollPosition = 0; // Reset previous scroll position
    }
  }
});

updateTranslateFactor();

window.addEventListener('scroll', function() {
  if (window.innerWidth > 1400) {
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    const bannerImg = document.querySelector('.banner-bottom-img img');
      if(bannerImg) {
        
    if (currentScroll > previousScrollPosition) {
      translateYValue += (currentScroll - previousScrollPosition) / translateFactor;
    } else {
      translateYValue -= (previousScrollPosition - currentScroll) / translateFactor;
    }
    }

    bannerImg.style.transform = `translate(0%, ${translateYValue}px)`;
    previousScrollPosition = currentScroll <= 0 ? 0 : currentScroll;
  }
});

// accordion
$(document).ready(function () {
    function setAccordionState() {
        $(".custom-accordion-section").each(function () {
            var section = $(this);
            section.find(".accordion-item").removeClass("active");
            section.find(".accordion-content").slideUp(0);
            if ($(window).width() > 768) {
                section.find(".accordion-item:first").addClass("active").find(".accordion-content").slideDown(0);
            }
        });
    }

    setAccordionState();

    $(window).resize(function () {
        setAccordionState();
    });

    $(".custom-accordion-section").each(function () {
        var section = $(this);

        section.find(".accordion-header").click(function () {
            var content = $(this).next(".accordion-content");
            var item = $(this).parent();

            if (!content.is(":visible")) {
                section.find(".accordion-content").slideUp();
                section.find(".accordion-item").removeClass("active");
                item.addClass("active");
                content.slideDown();
            } else {
                item.removeClass("active");
                content.slideUp();
            }
        });
    });
});



 $(document).ready(function() {
      // Show popup on button click (for demo)
     $('.shipping-info-list > li').click(function() {
        $('.popup-overlay').addClass("active");
        const attr = $(this).data("id");
        $(`.popup-overlay [data-tab="${attr}"]`).trigger("click");
       $("#MainContent").toggleClass("active");
       $("html").toggleClass("overflow-hidden");
    });

      
      // Close popup when clicking the close button
      $('.popup-overlay .close-btn').click(function() {
        $('.popup-overlay').removeClass("active");
        $("#MainContent").removeClass("active");
            $("html").removeClass("overflow-hidden");
      });
      
      // Tab switching functionality
      $('.popup-overlay .tab').click(function() {
        // Remove active class from all tabs and content
        $('.popup-overlay .tab').removeClass('active');
        $('.popup-overlay .tab-content').removeClass('active');
        
        // Add active class to clicked tab
        $(this).addClass('active');
        
        // Show corresponding content
        var tabId = $(this).data('tab');
        $('#' + tabId).addClass('active');
      });
      
      // Close when clicking outside the popup (optional)
      $('.popup-overlay').click(function(e) {
        if (e.target === this) {
          $(this).removeClass("active");
          $("#MainContent").removeClass("active");
          $("html").removeClass("overflow-hidden");
        }
      });
    });

